import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from '@mui/material';
import { formatCurrency, formatNum } from './dashboardUtils';

const COLUMN_COUNT = 4;

/** Rows: { month, orders, total_sales (converted leads), revenue } */
export default function DashboardMonthlySalesTable({ monthlySales, loading }) {
  const list = Array.isArray(monthlySales) ? monthlySales : [];

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Monthwise Sales
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.100' }}>
                <TableCell sx={{ fontWeight: 600 }}>Month</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Orders</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Sales (Paid Orders)</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Revenue</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                [...Array(5)].map((_, i) => (
                  <TableRow key={i}>
                    <TableCell colSpan={COLUMN_COUNT}><Skeleton height={28} /></TableCell>
                  </TableRow>
                ))
              ) : list.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={COLUMN_COUNT} sx={{ textAlign: 'center', py: 3 }}>No data found.</TableCell>
                </TableRow>
              ) : (
                list.map((row, i) => (
                  <TableRow key={row.month_key ?? row.month ?? i}>
                    <TableCell sx={{ fontWeight: 600 }}>{row.month ?? '—'}</TableCell>
                    <TableCell align="right">{formatNum(row.orders)}</TableCell>
                    <TableCell align="right">{formatNum(row.total_sales)}</TableCell>
                    <TableCell align="right">{formatCurrency(row.revenue ?? 0)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
